import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueMask from 'v-mask'
import VueScrollTo from 'vue-scrollto';
import myApi from './gavnoCode/ApiHandler';
import palantir from "./gavnoCode/palantir";
import axios from 'axios';
import external from "@/gavnoCode/external";
//
// import VueGtm from 'vue-gtm';



import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

Vue.config.productionTip = false;
Vue.prototype.$myApi = myApi;
Vue.prototype.$external = external;
Vue.prototype.$palantir = palantir;
Vue.prototype.$axios = axios;

Vue.use(VueMask);
Vue.use(VueScrollTo);


// Vue.use(VueGtm, {
//   id: 'GTM-5XXJ8CC'
// });

import myFilter from './gavnoCode/filters';

import router from './router'
for(let name in myFilter) {
  Vue.filter(name, myFilter[name]);
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
